import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [role, setRole] = useState(null);
  const [requirePasswordChange, setRequirePasswordChange] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userRole = localStorage.getItem('role');
    const userId = localStorage.getItem('userId');
    const passwordChangeRequired = localStorage.getItem('requirePasswordChange') === 'true';

    if (token && userRole && userId) {
      setIsAuthenticated(true);
      setRole(userRole.toLowerCase());
      setRequirePasswordChange(passwordChangeRequired);
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated !== null && role !== null) {
      if (!isAuthenticated) {
        navigate('/login', { replace: true });
      } else if (requirePasswordChange && location.pathname !== '/change-password') {
        // Om lösenordsbyte krävs och användaren inte är på lösenordsbytessidan
        navigate('/change-password', { replace: true });
      } else if (location.pathname === '/') {
        // Omdirigera endast från root-path baserat på roll + user-preferens.
        // Roller som har Vecka-tillgång kan välja default via Inställningar.
        const veckaRoles = ['byggkonsult', 'inredningsarkitekt', 'admin', 'byggare'];
        const landingView = localStorage.getItem('defaultLandingView') || 'oversikt';
        const prefersVecka = veckaRoles.includes(role) && landingView === 'vecka';

        if (prefersVecka) {
          navigate('/workspace/vecka', { replace: true });
          return;
        }

        switch (role) {
          case 'admin':
            navigate('/dashboard', { replace: true });
            break;
          case 'kund':
            navigate('/myprojects', { replace: true });
            break;
          case 'byggkonsult':
          case 'inredningsarkitekt':
            navigate('/workspace/oversikt', { replace: true });
            break;
          case 'byggare':
          case 'ue':
          case 'projektor':
          case 'materialleverantör':
            navigate('/workspace/oversikt', { replace: true });
            break;
          default:
            navigate('/login', { replace: true });
        }
      }
    }
  }, [isAuthenticated, role, navigate, location, requirePasswordChange]);

  // Vänta tills isAuthenticated är hämtat
  if (isAuthenticated === null) {
    return <div>Laddar...</div>;
  }

  // Om användaren inte är autentiserad, visa ingenting
  if (!isAuthenticated) {
    return null;
  }

  // Om lösenordsbyte krävs men användaren inte är på lösenordsbytessidan, visa ingenting
  if (requirePasswordChange && location.pathname !== '/change-password') {
    return null;
  }

  // Om användaren är autentiserad, visa innehållet
  return children;
};

export default PrivateRoute;